module.exports = __webpack_public_path__ + "static/img3-5098a7978d8c5d42856920c70cf6a986.jpg";